<template>
  <v-card>
    <v-card-title>
      <div
        class="h4 d-flex"
        style="cursor: pointer;"
        @click="navigateToDashboard"
      >
        <v-icon
          dark
          color="#C6CCD0"
          >mdi-view-dashboard</v-icon
        >
        <div class="text-button pl-1">Dashboard</div>
      </div>
    </v-card-title>
    <v-card-title primary-title class="justify-center">Lake5 Metadata</v-card-title>
    <v-card-text class="justify-center">
      <iframe
        width="2200"
        height="1000"
        :src="iframeSrc"
        frameborder="0"
        allowfullscreen
      >
      </iframe>
    </v-card-text>
  </v-card>
</template>

<script>
  import { ROUTE_BACK } from '@/appLogic/route/store/actions'

  export default {
    data() {
      return {
        iframeSrc:
          'https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/282834144934/dashboards/aee295f1-4b4f-49b3-b009-642678d663b1?directory_alias=audience-matters-nonprod-qs',
      }
    },
    methods: {
      navigateToDashboard() {
        this.$store.dispatch(ROUTE_BACK)
      },
    },
  }
</script>

<style scoped>
  /* Add any specific styles for your iframe here */
</style>



// WEBPACK FOOTER //
// QuickSightDashboard.vue?330a3480